import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/api/v1/passengers/list', data, {params})
  },
  save(data){
    return http.post('/api/v1/passengers', data)
  },
  get(id) {
    return http.get(`/api/v1/passengers/${id}`)
  },
  update(id, data) {
    return http.put(`/api/v1/passengers/${id}`, data)
  },
  changeStatus(id, status) {
    return http.put(`/api/v1/passengers/${id}/status`, null, {
      params: { status },
    });
  },
  getByPhone(phone) {
    return http.get(`/api/v1/passengers/by-phone/${encodeURIComponent(phone)}`)
  },
  search(phone) {
    return http.get('/api/v1/passengers/search', { params: { phone } })
  },
  detectCountry(phone) {
    return http.get('/api/v1/passengers/detect-country', { params: { phone } })
  },
  getSuggestedPriceType(id, segment) {
    return http.get(`/api/v1/passengers/${id || 0}/suggested-price-type`, { params: { segment } })
  }
}
